import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate('/admin', { replace: true });
      return;
    }
    const session_id = match[1];

    (async () => {
      try {
        await axios.post(`${API}/auth/session`, { session_id }, { withCredentials: true });
        // Strip hash and redirect to admin
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/admin', { replace: true });
      } catch (e) {
        console.error('Auth failed:', e);
        navigate('/admin?auth_error=1', { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#FAFAF8] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-10 h-10 text-[#1D4E41] animate-spin mx-auto mb-3" />
        <p className="text-gray-500">Iniciando sesión...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
